import React from 'react'
import DataLoader from '../data/DataLoader'
import Footer from '../footer/Footer'
import Testimonials from '../testimonials/Testimonials'
import {withRouter} from 'react-router-dom'

class LegalPage extends React.Component {
  render () {


    let content = this.props.content


    //console.log("About Page",content);

    let styleObject = {
        maxWidth : '800px',
        margin: '50px auto'
    }


    return(
      <div className="standard-page legal-page" ref="container">
        <section className="header content-row">
          <div className="inner">
            <h1 className="page-title" dangerouslySetInnerHTML={{__html:content.title.rendered}}></h1>
            <div className="intro" ></div>
          </div>
        </section>

        <div className="content-row">
          <div style={styleObject} dangerouslySetInnerHTML={{__html:content.content.rendered}}></div>

        </div>




      <Footer></Footer>
      </div>
    )

  }
}

export default withRouter(LegalPage);



// WEBPACK FOOTER //
// ./src/modules/pages/LegalPage.js